import { buildUrl } from 'Util/FetchUtils';

export const SERVER_URL = '';
export const BOOKING_ENTITY_URL = `${SERVER_URL}/api/entity/BookingEntity`;
export const CHECK_IN_STATUS_HISTORY_URL = `${SERVER_URL}/api/entity/CheckInStatusHistoryEntity`;
export const FERRY_BOOKING_URL = `${SERVER_URL}/api/FerryBooking`;
export const FERRY_TRIP_ENTITY_URL = `${SERVER_URL}/api/entity/FerryTripEntity`;
export const EVENT_BOOKING_URL = `${SERVER_URL}/api/EventBooking`;
export const ROUTE_ENTITY_URL = `${SERVER_URL}/api/entity/RouteEntity`;
export const LOCATION_ENTITY_URL = `${SERVER_URL}/api/entity/LocationEntity`;
export const PASSENGER_TYPE_ENTITY_URL = `${SERVER_URL}/api/entity/PassengerTypeEntity`;
export const ADDITIONAL_OPTION_ENTITY_URL = `${SERVER_URL}/api/entity/AdditionalBookingOptionEntity`;
export const EVENT_DETAIL_ENTITY_URL = `${SERVER_URL}/api/entity/EventDetailEntity`;
export const EVENT_SERIES_ENTITY_URL = `${SERVER_URL}/api/entity/EventSeriesEntity`;
export const TRANSACTION_ENTITY_URL = `${SERVER_URL}/api/entity/TransactionEntity`;
export const LANGUAGE_ENTITY_URL = `${SERVER_URL}/api/entity/LanguageEntity`;
export const ENTITLEMENT_PRODUCT_API_URL = `${SERVER_URL}/api/EntitlementProduct`;
export const POS_PRODUCT_API_URL = `${SERVER_URL}/api/PosProduct`;
export const ANYTIME_PRODUCTS_API_URL = `${SERVER_URL}/api/Sales/available-products`;
export const JOURNEY_API = `${SERVER_URL}/api/journey`;
export const LICENSE_PLATE_API = `${SERVER_URL}/api/licenseplate`;
export const FERRY_TRIP_API_URL = `${SERVER_URL}/api/entity/FerryTripEntity`;
export const RECURRENCE_API_URL = `${SERVER_URL}/api/entity/RecurrenceEntity`;
export const PRICING_API = `${SERVER_URL}/api/Pricing`;
export const USER_FIXED_PRICING_API = `${SERVER_URL}/api/UserFixedPricing`;
export const VOUCHER_API = `${SERVER_URL}/api/entity/GiftCertificateEntity`;
export const VOUCHER_DISCOUNT_API = `${SERVER_URL}/api/VoucherAndDiscount`;
export const DISCOUNT_API = `${SERVER_URL}/api/entity/DiscountEntity`;
export const CARGO_TYPE_API_URL = `${SERVER_URL}/api/entity/CargoTypeEntity`;
export const USER_DISPLAY_NAME_API_URL = `${SERVER_URL}/api/entity/UserDisplayNameEntity`;
export const DYNAMIC_BOOKING_FIELD_API_URL = `${SERVER_URL}/api/entity/DynamicBookingFieldEntity`;
export const DYNAMIC_BOOKING_SECTION_API_URL = `${SERVER_URL}/api/entity/DynamicBookingSectionEntity`;
export const WIZARD_DATA_API = `${SERVER_URL}/api/booking-wizard-data`;
export const CACHE_API = `${SERVER_URL}/api/cache`;
export const VEHICLE_TYPE_API = `${SERVER_URL}/api/entity/CargoTypeEntity`;
export const REFUND_API = `${SERVER_URL}/api/entity/RefundEntity`;
export const TRAPPED_COMMUNICATIONS_API = `${SERVER_URL}/api/trapped-communications`;
export const CONFIG_THEME_API_URL = `${SERVER_URL}/api/entity/ConfigThemeEntity`;
export const API_ENDPOINTS = {
	APPLICATION_CONFIG: {
		GET_ALL: `${SERVER_URL}/api/entity/ApplicationConfigEntity/all`,
		PATCH: (id: string) => `${SERVER_URL}/api/entity/ApplicationConfigEntity/${id}`,
		PATCH_MANY: `${SERVER_URL}/api/entity/ApplicationConfigEntity/many`,
		ATTACHED_ENTITIES: (entityType: string) =>
			`${SERVER_URL}/api/entity/ApplicationConfigEntity/attached-entities/${entityType}`,
	},
	AUDITING: {
		FERRY_TRIPS: `${SERVER_URL}/api/auditing/ferry-trips`,
		APP_CONFIG: `${SERVER_URL}/api/auditing/app-config`,
		SCHEDULED_REPORTS: `${SERVER_URL}/api/auditing/scheduled-reports`,
		PROMOTIONS: `${SERVER_URL}/api/auditing/promotions`,
		BACKGROUND_JOB_SCHEDULES: `${SERVER_URL}/api/auditing/background-job-schedules`,
		BACKGROUND_JOB_SETTINGS: `${SERVER_URL}/api/auditing/background-job-settings`,
		COMMUNICATION_TEMPLATES: `${SERVER_URL}/api/auditing/communication-templates`,
		USERS: `${SERVER_URL}/api/auditing/users`,
	},
	BANNER: {
		GET_BANNER_LIST: `${SERVER_URL}/api/banner`,
		GET_BANNER: (id: string) => `${SERVER_URL}/api/banner/${id}`,
		PATCH_BANNER: (id: string) => `${SERVER_URL}/api/banner/${id}`,
		POST_CREATE_BANNER: `${SERVER_URL}/api/banner`,
		PUT_UPDATE_BANNER: (id: string) => `${SERVER_URL}/api/banner/${id}`,
		DELETE: (id: string) => `${SERVER_URL}/api/banner/${id}`,
	},
	BOOKINGS: {
		POST_RESEND_CONFIRMATION: `${SERVER_URL}/api/entity/BookingEntity/resend-confirmation`,
	},
	CHARTERS: {
		GET_SCHEDULE: `${SERVER_URL}/api/charters`,
		GET_ONE: (id: string) => `${SERVER_URL}/api/charters/${id}`,
		POST_CREATE: `${SERVER_URL}/api/charters`,
		PUT_UPDATE: (id: string) => `${SERVER_URL}/api/charters/${id}`,
		POST_BOOK: (id: string) => `${SERVER_URL}/api/charters/${id}/book`,
		POST_CANCEL: (id: string) => `${SERVER_URL}/api/charters/${id}/cancel`,
		POST_MARK_INVOICED: (id: string) => `${SERVER_URL}/api/charters/${id}/mark-invoiced`,
		POST_UNDO_INVOICED: (id: string) => `${SERVER_URL}/api/charters/${id}/undo-invoiced`,
		/**
		 * A page of the charters table, filtered and paged on the server. Every charter by default,
		 * or one customer's with `userId` — the tab on /staff-bookings and the tab on their page.
		 */
		GET_LIST: `${SERVER_URL}/api/charters/list`,
		/**
		 * The same page of the same table, scoped by the server to whoever is asking — what a customer
		 * on /staff-bookings reads, since `/api/charters` is staff-only at the class level. Answers the
		 * same `data` / `count` shape, so one frontend reads either.
		 */
		GET_MINE_LIST: `${SERVER_URL}/api/customer-charters/list`,
		/** The signed-in customer's own booked charters, and one of them. */
		GET_MINE: `${SERVER_URL}/api/customer-charters`,
		GET_MINE_ONE: (id: string) => `${SERVER_URL}/api/customer-charters/${id}`,
	},
	TRIPS: {
		GET: (id: string) => `${SERVER_URL}/api/entity/FerryTripEntity/trip-schedule/${id}`,
		ELEMENTS: `${SERVER_URL}/api/entity/FerryTripEntity/elements`,
		SCHEDULE: `${SERVER_URL}/api/trips/schedule`,
		LIST_FILTERED: `${SERVER_URL}/api/trips/list-filtered`,
		CHECK_CAPACITY: `${SERVER_URL}/api/trips/check-capacity`,
		GET_TRIP_BOOKINGS: (id: string) => `${SERVER_URL}/api/entity/FerryTripEntity/${id}/bookings`,
		POST_TRIP_BOOKINGS: `${SERVER_URL}/api/trips/booking-comms`,
		GET_TRIPS_BOOKINGS_COUNT: `${SERVER_URL}/api/trips/booking-count`,
		POST_CANCEL_TRIPS: `${SERVER_URL}/api/trips/cancel`,
		POST_BULK_UPDATE: `${SERVER_URL}/api/entity/FerryTripEntity/bulk-update`,
		POST_BULK_CAPACITY_CHANGE_PREVIEW: `${SERVER_URL}/api/trips/bulk-capacity-change/preview`,
		POST_SAMPLE_CUSTOM_CSV: `${SERVER_URL}/api/entity/FerryTripEntity/sample-custom-csv`,
		POST_SAMPLE_DEFAULT_CSV: `${SERVER_URL}/api/entity/FerryTripEntity/sample-default-csv`,
		// Draft trips (a trip in a pending import batch, or created as a draft).
		GET_DRAFT: (id: string) => `${SERVER_URL}/api/trips/${id}/draft`,
		POST_PUBLISH_DRAFT: (id: string, wholeSeries: boolean) =>
			`${SERVER_URL}/api/trips/${id}/draft/publish?wholeSeries=${wholeSeries}`,
		DELETE_DRAFT: (id: string) => `${SERVER_URL}/api/trips/${id}/draft`,
		PUT_DRAFT_VISIBILITY: (id: string) => `${SERVER_URL}/api/trips/${id}/draft/visibility`,
		// The trip sidebar's History tab.
		GET_HISTORY: (id: string) => `${SERVER_URL}/api/trips/${id}/history`,
		GET_HISTORY_ENTRY: (id: string, entryId: string) => `${SERVER_URL}/api/trips/${id}/history/${entryId}`,
		// The trip sidebar's Releases tab.
		GET_RELEASES: (id: string) => `${SERVER_URL}/api/trips/${id}/releases`,
		PUT_RELEASES: (id: string) => `${SERVER_URL}/api/trips/${id}/releases`,
		POST_RELEASE_NOW: (id: string) => `${SERVER_URL}/api/trips/${id}/releases/release-now`,
		POST_MOVE_TO_DRAFT: (id: string) => `${SERVER_URL}/api/trips/${id}/releases/move-to-draft`,
		POST_RETURN_TO_SCHEDULE: (id: string) => `${SERVER_URL}/api/trips/${id}/releases/return-to-schedule`,
	},
	CHECK_IN: {
		// Check-in's History screen: what was done from check-in on a trip, and who did it.
		GET_HISTORY: (tripId: string) => `${SERVER_URL}/api/check-in/trips/${tripId}/history`,
		GET_HISTORY_STAFF: (tripId: string) => `${SERVER_URL}/api/check-in/trips/${tripId}/history/staff`,
	},
	RECURRING_SCHEDULES: {
		LIST: `${SERVER_URL}/api/recurring-schedules`,
		OPTIONS: `${SERVER_URL}/api/recurring-schedules/options`,
		PRICES: `${SERVER_URL}/api/recurring-schedules/prices`,
		PREVIEW: `${SERVER_URL}/api/recurring-schedules/preview`,
		IMPORT_DEPARTURES: `${SERVER_URL}/api/recurring-schedules/import-departures`,
		CREATE: `${SERVER_URL}/api/recurring-schedules`,
		GET: (id: string) => `${SERVER_URL}/api/recurring-schedules/${id}`,
		UPDATE: (id: string) => `${SERVER_URL}/api/recurring-schedules/${id}`,
		DELETE: (id: string) => `${SERVER_URL}/api/recurring-schedules/${id}`,
		IMPACT: (id: string) => `${SERVER_URL}/api/recurring-schedules/${id}/impact`,
		HISTORY: (id: string) => `${SERVER_URL}/api/recurring-schedules/${id}/history`,
		PAUSE: (id: string) => `${SERVER_URL}/api/recurring-schedules/${id}/pause`,
		SKIP: (id: string) => `${SERVER_URL}/api/recurring-schedules/${id}/skips`,
		UNSKIP: (id: string) => `${SERVER_URL}/api/recurring-schedules/${id}/skips/undo`,
		RETRY: (id: string) => `${SERVER_URL}/api/recurring-schedules/${id}/retry`,
		CHECK: (id: string) => `${SERVER_URL}/api/recurring-schedules/${id}/check`,
		RUN: (id: string, runId: string) => `${SERVER_URL}/api/recurring-schedules/${id}/runs/${runId}`,
		ARCHIVE: (id: string) => `${SERVER_URL}/api/recurring-schedules/${id}/archive`,
		COPY: (id: string) => `${SERVER_URL}/api/recurring-schedules/${id}/copy`,
		PAUSE_SCHEDULE: (id: string) => `${SERVER_URL}/api/recurring-schedules/${id}/pause-schedule`,
		RESUME: (id: string) => `${SERVER_URL}/api/recurring-schedules/${id}/resume`,
	},
	TRIP_IMPORTS: {
		LIST: `${SERVER_URL}/api/trip-imports`,
		GET: (id: string) => `${SERVER_URL}/api/trip-imports/${id}`,
		PARSE: `${SERVER_URL}/api/trip-imports/parse`,
		VALIDATE: `${SERVER_URL}/api/trip-imports/validate`,
		RECURRENCE_ROWS: `${SERVER_URL}/api/trip-imports/recurrence-rows`,
		TEMPLATE_COLUMNS: `${SERVER_URL}/api/trip-imports/template-columns`,
		OPTIONS: `${SERVER_URL}/api/trip-imports/options`,
		CREATE: `${SERVER_URL}/api/trip-imports`,
		SAVE: (id: string) => `${SERVER_URL}/api/trip-imports/${id}`,
		UPLOAD: (id: string) => `${SERVER_URL}/api/trip-imports/${id}/upload`,
		PUBLISH: (id: string) => `${SERVER_URL}/api/trip-imports/${id}/publish`,
		RUN: (runId: string) => `${SERVER_URL}/api/trip-imports/runs/${runId}`,
		ACTIVE_RUN: (id: string) => `${SERVER_URL}/api/trip-imports/${id}/active-run`,
		DELETE: (id: string) => `${SERVER_URL}/api/trip-imports/${id}`,
		LOCK: (id: string) => `${SERVER_URL}/api/trip-imports/${id}/lock`,
		LOCK_RELEASE: (id: string) => `${SERVER_URL}/api/trip-imports/${id}/lock/release`,
		LOCK_TAKEOVER: (id: string) => `${SERVER_URL}/api/trip-imports/${id}/lock/takeover`,
		VISIBILITY: (id: string) => `${SERVER_URL}/api/trip-imports/${id}/visibility`,
		SHARE_CANDIDATES: `${SERVER_URL}/api/trip-imports/share-candidates`,
		HISTORY: (id: string) => `${SERVER_URL}/api/trip-imports/${id}/history`,
		SNAPSHOT_CSV: (id: string, changeId: string) => `${SERVER_URL}/api/trip-imports/${id}/history/${changeId}/csv`,
		BLANK: `${SERVER_URL}/api/trip-imports/blank`,
		TEMPLATE_PRICES: `${SERVER_URL}/api/trip-imports/template-prices`,
		TAKE_OFF_SCHEDULE: (id: string) => `${SERVER_URL}/api/trip-imports/${id}/take-off-schedule`,
		RENAME: (id: string) => `${SERVER_URL}/api/trip-imports/${id}/name`,
		COPY: (id: string) => `${SERVER_URL}/api/trip-imports/${id}/copy`,
		COMMENTS: (id: string) => `${SERVER_URL}/api/trip-imports/${id}/comments`,
		COMMENT_PEOPLE: (id: string) => `${SERVER_URL}/api/trip-imports/${id}/comment-people`,
		COMMENT: (id: string, commentId: string) => `${SERVER_URL}/api/trip-imports/${id}/comments/${commentId}`,
	},
	JOURNEY: {
		GET_SCHEDULE: (tripId: string, startStopId: string, endStopId: string) => {
			return buildUrl(`${SERVER_URL}/api/journey/schedule`, { tripId, startStopId, endStopId });
		},
	},
	NOTIFICATIONS: {
		POST_TRIP_STOP: `${SERVER_URL}/api/notifications/trip-stop/batch`,
	},
	PRICING: {
		GET_BASE_TICKET_PRICE: `${SERVER_URL}/api/Pricing/get-base-ticket-price`,
		GET_TRIP_CLASS_PRICES: `${SERVER_URL}/api/Pricing/get-trip-class-prices`,
		GET_DEFAULT_PRICING: (id: string) => `${SERVER_URL}/api/default-pricing/${id}`,
		GET_EXISTS: (name: string, id?: string) =>
			`${SERVER_URL}/api/default-pricing/exists?name=${name}${id ? `&id=${id}` : ''}`,
		GET_DEFAULT_PRICING_LIST: `${SERVER_URL}/api/default-pricing`,
		POST_DEFAULT_PRICING: `${SERVER_URL}/api/experimental/default-pricing`,
		POST_CREATE_DEFAULT_PRICING: `${SERVER_URL}/api/default-pricing`,
		POST_FREIGHT_DETAIL_CALCULATION: `${SERVER_URL}/api/Pricing/freight-detail/calculation`,
		// Bulk increase/decrease of trip prices across a date range, filtered by ferry time + direction.
		// NOTE: backend endpoint not yet implemented — consumed by the Bulk Trip Pricing wizard's execute step.
		POST_BULK_TRIP_PRICING: `${SERVER_URL}/api/Pricing/bulk-trip-pricing`,
		// Resolves the trips a selection matches + their current prices, for the wizard's review step.
		POST_BULK_TRIP_PRICING_PREVIEW: `${SERVER_URL}/api/Pricing/bulk-trip-pricing/preview`,
		GET_BULK_TRIP_PRICING_RUN: (id: string) => `${SERVER_URL}/api/Pricing/bulk-trip-pricing/run/${id}`,
		// CSV report of a run's updated trips (each changed price, previous → new).
		GET_BULK_TRIP_PRICING_RUN_REPORT: (id: string) =>
			`${SERVER_URL}/api/Pricing/bulk-trip-pricing/run/${id}/report`,
		GET_ACTIVE_BULK_TRIP_PRICING_RUN: `${SERVER_URL}/api/Pricing/bulk-trip-pricing/run/active`,
		// What a reprice WOULD do to the selected invoiced bookings. Read-only — the backend computes on
		// an untracked graph and never saves, so it is safe to call as often as the wizard likes.
		POST_INVOICED_BOOKING_REPRICE_PREVIEW: `${SERVER_URL}/api/Pricing/invoiced-booking-reprice/preview`,
		// Enqueues the reprice; returns 202 + a run id to poll. The write happens out-of-request.
		POST_INVOICED_BOOKING_REPRICE: `${SERVER_URL}/api/Pricing/invoiced-booking-reprice`,
		GET_INVOICED_BOOKING_REPRICE_RUN: (id: string) =>
			`${SERVER_URL}/api/Pricing/invoiced-booking-reprice/run/${id}`,
		// CSV report of a run's repriced bookings (previous total → new total).
		GET_INVOICED_BOOKING_REPRICE_RUN_REPORT: (id: string) =>
			`${SERVER_URL}/api/Pricing/invoiced-booking-reprice/run/${id}/report`,
		GET_ACTIVE_INVOICED_BOOKING_REPRICE_RUN: `${SERVER_URL}/api/Pricing/invoiced-booking-reprice/run/active`,
		PUT_UPDATE_DEFAULT_PRICING: (id: string) => `${SERVER_URL}/api/default-pricing/${id}`,
		DELETE_DEFAULT_PRICING: (id: string) => `${SERVER_URL}/api/default-pricing/${id}`,
		LUNIO_PRICING_GRAPH: `${SERVER_URL}/api/lunio-pricing/graph`,
	},
	STANDBY: {
		GET_LIST: (ferryTripId: string, includeRemoved = false) =>
			`${SERVER_URL}/api/standby/list?ferryTripId=${ferryTripId}${includeRemoved ? '&includeRemoved=true' : ''}`,
		POST_ADD: `${SERVER_URL}/api/standby`,
		DELETE: (id: string) => `${SERVER_URL}/api/standby/${id}`,
		GET_MY_COUNT: (ferryTripIds: string[]) =>
			`${SERVER_URL}/api/standby/mine/count?${ferryTripIds.map(id => `ferryTripIds=${encodeURIComponent(id)}`).join('&')}`,
	},
	USER: {
		GET_SEARCH: `${SERVER_URL}/api/entity/UserEntity/search`,
	},
	WIZARD: {
		GET_WIDTHS: `${SERVER_URL}/api/booking-wizard-data/widths`,
	},
} as const;

export const ORGANISATION_API = `${SERVER_URL}/api/entity/OrganisationEntity`;
export const APPLICATION_NAME = 'Ferryhawk';
export const FAVICON_URL = '/api/entity/ConfigThemeEntity/image/favicon';
export const FEATURE_IMAGE_1_URL = '/api/entity/ConfigThemeEntity/image/homepageBackgroundImage';
export const FEATURE_IMAGE_2_URL = '/api/entity/ConfigThemeEntity/image/bookingWizardBackgroundImage';
export const FEATURE_IMAGE_3_URL = '/api/entity/ConfigThemeEntity/image/customerRegistrationSideImage';
export const FEATURE_IMAGE_4_URL = '/api/entity/ConfigThemeEntity/image/errorPageBackgroundImage';
export const FEATURE_IMAGE_5_URL = '/api/entity/ConfigThemeEntity/image/bookingSuccessBackgroundImage';
export const FEATURE_IMAGE_6_URL = '/api/entity/ConfigThemeEntity/image/pageNotFoundBackgroundImage';
export const FEATURE_IMAGE_7_URL = '/api/entity/ConfigThemeEntity/image/bookingSuccessPromoCardImage';

export const LOGO_PRIMARY_DARK = '/api/entity/ConfigThemeEntity/image/logoPrimaryDark';
export const LOGO_PRIMARY_LIGHT = '/api/entity/ConfigThemeEntity/image/logoPrimaryLight';

export const EVENT_IMAGE = '/api/entity/UploadedImageEntity/image/';
export const IMAGE_API_URL = '/api/files/';
export const DEFAULT_COUNTRY_CODE = 'AU';

export const ROUTES = {
	ERROR: '/404',
	BOOKING_CANCELLED_SUCCESS: {
		path: '/booking-cancelled-success',
		url: (
			transactionId: string,
			firstName: string,
			lastName: string,
			bookingId?: string,
			isEventBooking?: boolean,
		) => {
			let url =
				`/booking-cancelled-success?id=${transactionId}` +
				`&userFirstName=${firstName.trim()}` +
				`&userLastName=${lastName.trim()}`;
			if (bookingId) url += `&bookingId=${bookingId}`;
			// Lets the success page paint the correct heading/spiel on first render instead
			// of waiting for the booking fetch to learn the type.
			if (isEventBooking !== undefined) url += `&type=${isEventBooking ? 'event' : 'trip'}`;
			return url;
		},
	},
	BOOKING_WIZARD: {
		termsAndConditionsLoader: 't-and-cs:0',
		payment: '/booking-wizard/payment',
	},
	CHECKIN: '/check-in/:id/*',
	/**
	 * A customer's own charter, reached from their bookings. Not under `/bookings`, which is a
	 * booking's address and a charter is not a booking.
	 */
	CUSTOMER_CHARTER: {
		path: '/charters/:id',
		url: (id: string) => `/charters/${id}`,
	},
	CONVERT_GUEST: '/create-account',
	FERRY_SCHEDULE_EDIT: {
		path: '/ferry-schedule/edit/:id',
		url: (id: string, tab?: 'insights') => {
			const url = `/ferry-schedule/edit/${id}`;
			if (tab) {
				return `${url}?tab=${tab}`;
			}
			return url;
		},
	},
	FERRY_SCHEDULE_CREATE: {
		path: '/ferry-schedule/create',
		url: () => '/ferry-schedule/create',
	},
	FERRY_SCHEDULE_BULK_CANCEL_CONFIRMATION: '/ferry-schedule/bulk-cancel',
	FERRY_SCHEDULE_BULK_COMMUNICATIONS: '/ferry-schedule/bulk-communications',
	FERRY_SCHEDULE: '/ferry-schedule',
	/** Staff-only schedule, covering both ferry trips and charters. */
	STAFF_SCHEDULE: '/staff-schedule',
	/**
	 * A ferry trip's sidebar over the staff schedule. The same sidebar as
	 * `FERRY_SCHEDULE_EDIT`, under this page's own address, so opening a trip from the staff
	 * schedule returns to the staff schedule.
	 */
	STAFF_SCHEDULE_EDIT: {
		path: '/staff-schedule/edit/:id',
		url: (id: string) => `/staff-schedule/edit/${id}`,
	},
	/**
	 * A charter's sidebar over the staff schedule — where a charter is read and changed by staff.
	 *
	 * Named here rather than built by hand at each call site: three places now send a reader to it
	 * (the charters table, the schedule itself, and the back button on the customer charter view),
	 * and a string assembled three times is a string that can disagree with the route three ways.
	 */
	STAFF_SCHEDULE_CHARTER: {
		path: '/staff-schedule/charter/:id',
		url: (id: string) => `/staff-schedule/charter/${id}`,
	},
	/**
	 * The two bulk-action screens, under the staff schedule's own address so they mount inside its
	 * schedule provider. The `/ferry-schedule` pair below is the same screen reached from the
	 * customer schedule — see `bulkActionRoutes`.
	 */
	STAFF_SCHEDULE_BULK_CANCEL_CONFIRMATION: '/staff-schedule/bulk-cancel',
	STAFF_SCHEDULE_BULK_COMMUNICATIONS: '/staff-schedule/bulk-communications',
	FERRY_TRIPS: '/ferry-trips',
	FERRY_TRIPS_EDIT: {
		path: '/ferry-trips/edit/:id',
		url: (id: string) => `/ferry-trips/edit/${id}`,
	},
	REGISTER_CUSTOMER: '/register-customer',
	/** Legacy route — redirects to USER_DETAIL (bookings tab). Kept for old bookmarks/links. */
	SEARCH_RESULTS: {
		path: '/search-results/:id',
	},
	USERS: '/users',
	USER_DETAIL: {
		path: '/users/:id/:tab?',
		url: (id: string, tab?: string) => `/users/${id}${tab ? `/${tab}` : ''}`,
	},
	ADMIN: {
		APP_CONFIG: 'app-config',
		HOME: '/admin',
		AUDITING: 'auditing',
		TRAPPED_COMMUNICATIONS: 'trapped-communications',
		BANNER_LIST: {
			path: 'banner',
		},
		BANNER_FORM_CREATE: {
			path: 'create',
		},
		BANNER_FORM_EDIT: {
			path: ':id/edit',
			buildUrl: (id: string) => `${id}/edit`,
		},
		BANNER_FORM_VIEW: {
			path: ':id',
			buildUrl: (id: string) => `${id}`,
		},
		FERRY_TRIP_IMPORT: {
			path: 'ferry-trip-import',
			LIST: {
				path: '',
				url: (tab?: 'Pending' | 'Published') => `/admin/ferry-trip-import${tab ? `?tab=${tab}` : ''}`,
			},
			NEW: { path: 'new', url: () => '/admin/ferry-trip-import/new' },
			EDIT: {
				path: ':id',
				url: (id: string, rowKey?: string) => `/admin/ferry-trip-import/${id}${rowKey ? `?row=${rowKey}` : ''}`,
			},
		},
		RECURRING_SCHEDULES: {
			path: 'recurring-schedules',
			LIST: {
				path: '',
				url: (tab?: 'Archived') => `/admin/recurring-schedules${tab ? `?tab=${tab}` : ''}`,
			},
			NEW: { path: 'new', url: () => '/admin/recurring-schedules/new' },
			EDIT: { path: ':id', url: (id: string) => `/admin/recurring-schedules/${id}` },
		},
		DEFAULT_PRICING: {
			path: 'default-pricing',
			LIST: { path: '', url: () => '/admin/default-pricing' },
			CREATE: { path: 'create', url: () => '/admin/default-pricing/create' },
			EDIT: { path: ':id/edit', url: (id: string) => `/admin/default-pricing/${id}/edit` },
			VIEW: { path: ':id', url: (id: string) => `/admin/default-pricing/${id}` },
		},
		BULK_TRIP_PRICING: {
			path: 'bulk-trip-pricing',
			url: () => '/admin/bulk-trip-pricing',
		},
		INVOICED_BOOKING_REPRICE: {
			path: 'invoiced-booking-reprice',
			url: () => '/admin/invoiced-booking-reprice',
		},
		EMAIL_BUILDER: {
			path: 'email-builder',
		},
		INTEGRATIONS: {
			path: 'integrations',
		},
		PRODUCTS: {
			LIST: {
				path: 'products',
				url: () => '/admin/products',
			},
			CREATE: {
				path: 'create',
				url: () => '/admin/products/create',
			},
			EDIT: {
				path: ':id/edit',
				url: (id: string) => `/admin/products/${id}/edit`,
			},
			VIEW: {
				path: ':id',
				url: (id: string) => `/admin/products/${id}`,
			},
		},
		POS_PRODUCTS: {
			LIST: {
				path: 'pos-products',
				url: () => '/admin/pos-products',
			},
			CREATE: {
				path: 'create',
				url: () => '/admin/pos-products/create',
			},
			EDIT: {
				path: ':id/edit',
				url: (id: string) => `/admin/pos-products/${id}/edit`,
			},
			VIEW: {
				path: ':id',
				url: (id: string) => `/admin/pos-products/${id}`,
			},
		},
		PROMOTIONS: {
			path: 'promotions',
			LIST: { path: '', url: () => '/admin/promotions' },
			CREATE: { path: 'create', url: () => '/admin/promotions/create' },
			EDIT: { path: ':id/edit', url: (id: string) => `/admin/promotions/${id}/edit` },
			VIEW: { path: ':id', url: (id: string) => `/admin/promotions/${id}` },
		},
		PARKING: {
			path: 'parking',
			LOCATIONS: {
				LIST: { path: 'locations', url: () => '/admin/parking/locations' },
				CREATE: { path: 'create', url: () => '/admin/parking/locations/create' },
				EDIT: { path: ':id/edit', url: (id: string) => `/admin/parking/locations/${id}/edit` },
				VIEW: { path: ':id', url: (id: string) => `/admin/parking/locations/${id}` },
			},
			VEHICLE_TYPES: {
				LIST: { path: 'vehicle-types', url: () => '/admin/parking/vehicle-types' },
				CREATE: { path: 'create', url: () => '/admin/parking/vehicle-types/create' },
				EDIT: { path: ':id/edit', url: (id: string) => `/admin/parking/vehicle-types/${id}/edit` },
				VIEW: { path: ':id', url: (id: string) => `/admin/parking/vehicle-types/${id}` },
			},
			PRICING: {
				LIST: { path: 'pricing', url: () => '/admin/parking/pricing' },
				CREATE: { path: 'create', url: () => '/admin/parking/pricing/create' },
				EDIT: { path: ':id/edit', url: (id: string) => `/admin/parking/pricing/${id}/edit` },
				VIEW: { path: ':id', url: (id: string) => `/admin/parking/pricing/${id}` },
			},
			CAPACITY: {
				LIST: { path: 'capacity', url: () => '/admin/parking/capacity' },
				CREATE: { path: 'create', url: () => '/admin/parking/capacity/create' },
				EDIT: { path: ':id/edit', url: (id: string) => `/admin/parking/capacity/${id}/edit` },
				VIEW: { path: ':id', url: (id: string) => `/admin/parking/capacity/${id}` },
			},
		},
		VEHICLE_TYPES: {
			path: 'vehicle-types',
			TYPES: {
				LIST: { path: 'types', url: () => '/admin/vehicle-types/types' },
				CREATE: { path: 'create', url: () => '/admin/vehicle-types/types/create' },
				EDIT: { path: ':id/edit', url: (id: string) => `/admin/vehicle-types/types/${id}/edit` },
				VIEW: { path: ':id', url: (id: string) => `/admin/vehicle-types/types/${id}` },
			},
			MEASUREMENTS: {
				LIST: { path: 'measurements', url: () => '/admin/vehicle-types/measurements' },
				CREATE: { path: 'create', url: () => '/admin/vehicle-types/measurements/create' },
				EDIT: { path: ':id/edit', url: (id: string) => `/admin/vehicle-types/measurements/${id}/edit` },
				VIEW: { path: ':id', url: (id: string) => `/admin/vehicle-types/measurements/${id}` },
			},
			CARGO_CHARACTERISTICS: {
				LIST: { path: 'cargo-characteristics', url: () => '/admin/vehicle-types/cargo-characteristics' },
				CREATE: { path: 'create', url: () => '/admin/vehicle-types/cargo-characteristics/create' },
				EDIT: {
					path: ':id/edit',
					url: (id: string) => `/admin/vehicle-types/cargo-characteristics/${id}/edit`,
				},
				VIEW: { path: ':id', url: (id: string) => `/admin/vehicle-types/cargo-characteristics/${id}` },
			},
			TOW_ON_TYPES: {
				LIST: { path: 'tow-on-types', url: () => '/admin/vehicle-types/tow-on-types' },
				CREATE: { path: 'create', url: () => '/admin/vehicle-types/tow-on-types/create' },
				EDIT: { path: ':id/edit', url: (id: string) => `/admin/vehicle-types/tow-on-types/${id}/edit` },
				VIEW: { path: ':id', url: (id: string) => `/admin/vehicle-types/tow-on-types/${id}` },
			},
			WIDTHS: {
				LIST: { path: 'widths', url: () => '/admin/vehicle-types/widths' },
				CREATE: { path: 'create', url: () => '/admin/vehicle-types/widths/create' },
				EDIT: { path: ':id/edit', url: (id: string) => `/admin/vehicle-types/widths/${id}/edit` },
				VIEW: { path: ':id', url: (id: string) => `/admin/vehicle-types/widths/${id}` },
			},
		},
		BOOKING_ADD_ONS: {
			path: 'booking-add-ons',
			OPTIONS: {
				LIST: { path: 'options', url: () => '/admin/booking-add-ons/options' },
				CREATE: { path: 'options/create', url: () => '/admin/booking-add-ons/options/create' },
				EDIT: { path: 'options/:id/edit', url: (id: string) => `/admin/booking-add-ons/options/${id}/edit` },
				VIEW: { path: 'options/:id', url: (id: string) => `/admin/booking-add-ons/options/${id}` },
			},
			SECTIONS: {
				LIST: { path: 'sections', url: () => '/admin/booking-add-ons/sections' },
				CREATE: { path: 'sections/create', url: () => '/admin/booking-add-ons/sections/create' },
				EDIT: { path: 'sections/:id/edit', url: (id: string) => `/admin/booking-add-ons/sections/${id}/edit` },
				VIEW: { path: 'sections/:id', url: (id: string) => `/admin/booking-add-ons/sections/${id}` },
			},
			CAPACITY_TYPES: {
				LIST: { path: 'capacity-types', url: () => '/admin/booking-add-ons/capacity-types' },
				CREATE: { path: 'capacity-types/create', url: () => '/admin/booking-add-ons/capacity-types/create' },
				EDIT: {
					path: 'capacity-types/:id/edit',
					url: (id: string) => `/admin/booking-add-ons/capacity-types/${id}/edit`,
				},
				VIEW: {
					path: 'capacity-types/:id',
					url: (id: string) => `/admin/booking-add-ons/capacity-types/${id}`,
				},
			},
			CAPACITY_RESTRICTIONS: {
				LIST: { path: 'capacity-restrictions', url: () => '/admin/booking-add-ons/capacity-restrictions' },
				CREATE: {
					path: 'capacity-restrictions/create',
					url: () => '/admin/booking-add-ons/capacity-restrictions/create',
				},
				EDIT: {
					path: 'capacity-restrictions/:id/edit',
					url: (id: string) => `/admin/booking-add-ons/capacity-restrictions/${id}/edit`,
				},
				VIEW: {
					path: 'capacity-restrictions/:id',
					url: (id: string) => `/admin/booking-add-ons/capacity-restrictions/${id}`,
				},
			},
		},
		BOOKING_CUTOFFS: {
			path: 'booking-cutoffs',
			LIST: { path: '', url: () => '/admin/booking-cutoffs' },
			CREATE: { path: 'create', url: () => '/admin/booking-cutoffs/create' },
			EDIT: { path: ':id/edit', url: (id: string) => `/admin/booking-cutoffs/${id}/edit` },
			VIEW: { path: ':id', url: (id: string) => `/admin/booking-cutoffs/${id}` },
		},
		FERRIES: {
			path: 'ferries',
			VESSELS: {
				LIST: { path: 'vessels', url: () => '/admin/ferries/vessels' },
				CREATE: { path: 'create', url: () => '/admin/ferries/vessels/create' },
				EDIT: { path: ':id/edit', url: (id: string) => `/admin/ferries/vessels/${id}/edit` },
				VIEW: { path: ':id', url: (id: string) => `/admin/ferries/vessels/${id}` },
			},
			CAPACITY_TYPES: {
				LIST: { path: 'capacity-types', url: () => '/admin/ferries/capacity-types' },
				CREATE: { path: 'create', url: () => '/admin/ferries/capacity-types/create' },
				EDIT: { path: ':id/edit', url: (id: string) => `/admin/ferries/capacity-types/${id}/edit` },
				VIEW: { path: ':id', url: (id: string) => `/admin/ferries/capacity-types/${id}` },
			},
			CAPACITY_PROFILES: {
				LIST: { path: 'capacity-profiles', url: () => '/admin/ferries/capacity-profiles' },
				CREATE: { path: 'create', url: () => '/admin/ferries/capacity-profiles/create' },
				EDIT: { path: ':id/edit', url: (id: string) => `/admin/ferries/capacity-profiles/${id}/edit` },
				VIEW: { path: ':id', url: (id: string) => `/admin/ferries/capacity-profiles/${id}` },
			},
			CAPACITY_RESTRICTIONS: {
				LIST: { path: 'capacity-restrictions', url: () => '/admin/ferries/capacity-restrictions' },
				CREATE: { path: 'create', url: () => '/admin/ferries/capacity-restrictions/create' },
				EDIT: { path: ':id/edit', url: (id: string) => `/admin/ferries/capacity-restrictions/${id}/edit` },
				VIEW: { path: ':id', url: (id: string) => `/admin/ferries/capacity-restrictions/${id}` },
			},
		},
		FREIGHT: {
			path: 'freight',
			CATEGORIES: {
				LIST: { path: 'categories', url: () => '/admin/freight/categories' },
				CREATE: { path: 'categories/create', url: () => '/admin/freight/categories/create' },
				EDIT: { path: 'categories/:id/edit', url: (id: string) => `/admin/freight/categories/${id}/edit` },
				VIEW: { path: 'categories/:id', url: (id: string) => `/admin/freight/categories/${id}` },
			},
			TYPES: {
				LIST: { path: 'types', url: () => '/admin/freight/types' },
				CREATE: { path: 'types/create', url: () => '/admin/freight/types/create' },
				EDIT: { path: 'types/:id/edit', url: (id: string) => `/admin/freight/types/${id}/edit` },
				VIEW: { path: 'types/:id', url: (id: string) => `/admin/freight/types/${id}` },
			},
			PRICE_RANGES: {
				LIST: { path: 'price-ranges', url: () => '/admin/freight/price-ranges' },
				CREATE: { path: 'price-ranges/create', url: () => '/admin/freight/price-ranges/create' },
				EDIT: { path: 'price-ranges/:id/edit', url: (id: string) => `/admin/freight/price-ranges/${id}/edit` },
				VIEW: { path: 'price-ranges/:id', url: (id: string) => `/admin/freight/price-ranges/${id}` },
			},
		},
		ROUTES_CRUD: {
			path: 'routes',
			ROUTES: {
				LIST: { path: 'routes', url: () => '/admin/routes/routes' },
				CREATE: { path: 'create', url: () => '/admin/routes/routes/create' },
				EDIT: { path: ':id/edit', url: (id: string) => `/admin/routes/routes/${id}/edit` },
				VIEW: { path: ':id', url: (id: string) => `/admin/routes/routes/${id}` },
			},
			LOCATIONS: {
				LIST: { path: 'locations', url: () => '/admin/routes/locations' },
				CREATE: { path: 'create', url: () => '/admin/routes/locations/create' },
				EDIT: { path: ':id/edit', url: (id: string) => `/admin/routes/locations/${id}/edit` },
				VIEW: { path: ':id', url: (id: string) => `/admin/routes/locations/${id}` },
			},
		},
		PASSENGER_TYPES: {
			path: 'passenger-types',
			LIST: { path: '', url: () => '/admin/passenger-types' },
			CREATE: { path: 'create', url: () => '/admin/passenger-types/create' },
			EDIT: { path: ':id/edit', url: (id: string) => `/admin/passenger-types/${id}/edit` },
			VIEW: { path: ':id', url: (id: string) => `/admin/passenger-types/${id}` },
		},
		USER_DISPLAY_NAMES: {
			path: 'customer-types',
			LIST: { path: '', url: () => '/admin/customer-types' },
			CREATE: { path: 'create', url: () => '/admin/customer-types/create' },
			EDIT: { path: ':id/edit', url: (id: string) => `/admin/customer-types/${id}/edit` },
			VIEW: { path: ':id', url: (id: string) => `/admin/customer-types/${id}` },
		},
		TOW_ON_TYPES: {
			path: 'tow-on-types',
			LIST: { path: '', url: () => '/admin/tow-on-types' },
			CREATE: { path: 'create', url: () => '/admin/tow-on-types/create' },
			EDIT: { path: ':id/edit', url: (id: string) => `/admin/tow-on-types/${id}/edit` },
			VIEW: { path: ':id', url: (id: string) => `/admin/tow-on-types/${id}` },
		},
		CHECK_IN_STATUSES: {
			path: 'check-in-statuses',
			LIST: { path: '', url: () => '/admin/check-in-statuses' },
			CREATE: { path: 'create', url: () => '/admin/check-in-statuses/create' },
			EDIT: { path: ':id/edit', url: (id: string) => `/admin/check-in-statuses/${id}/edit` },
			VIEW: { path: ':id', url: (id: string) => `/admin/check-in-statuses/${id}` },
		},
		CAPACITY_VISUALISER: {
			path: 'capacity-visualiser',
			url: () => '/admin/capacity-visualiser',
		},
		/** The Scheduling area's overview: Ferry Trips, the import, the historical viewer. */
		SCHEDULING: {
			path: 'scheduling',
			url: () => '/admin/scheduling',
		},
		HISTORICAL_SCHEDULE: {
			path: 'historical-schedule',
			url: () => '/admin/historical-schedule',
		},
		CUTOFF_RULE_TESTER: {
			path: 'cutoff-rule-tester',
			url: () => '/admin/cutoff-rule-tester',
		},
		LANGUAGES: {
			path: 'languages',
			LIST: { path: '', url: () => '/admin/languages' },
			CREATE: { path: 'create', url: () => '/admin/languages/create' },
			EDIT: { path: ':id/edit', url: (id: string) => `/admin/languages/${id}/edit` },
			VIEW: { path: ':id', url: (id: string) => `/admin/languages/${id}` },
		},
		CONFIG_GENERAL: {
			path: 'config-general',
			url: () => '/admin/config-general',
		},
		/**
		 * Kept on the original background-job-config path so existing bookmarks and the home-page
		 * link keep working, even though the screen is now a list of every recurring task rather
		 * than a form over one config row.
		 */
		BACKGROUND_JOBS: {
			path: 'background-job-config',
			LIST: { path: '', url: () => '/admin/background-job-config' },
			DETAIL: { path: ':key', url: (key: string) => `/admin/background-job-config/${key}` },
		},
		PASSENGER_CLASSES: {
			path: 'passenger-classes',
			LIST: { path: '', url: () => '/admin/passenger-classes' },
			CREATE: { path: 'create', url: () => '/admin/passenger-classes/create' },
			EDIT: { path: ':id/edit', url: (id: string) => `/admin/passenger-classes/${id}/edit` },
			VIEW: { path: ':id', url: (id: string) => `/admin/passenger-classes/${id}` },
		},
		EVENT_LABELS: {
			path: 'event-labels',
			LIST: { path: '', url: () => '/admin/event-labels' },
			CREATE: { path: 'create', url: () => '/admin/event-labels/create' },
			EDIT: { path: ':id/edit', url: (id: string) => `/admin/event-labels/${id}/edit` },
			VIEW: { path: ':id', url: (id: string) => `/admin/event-labels/${id}` },
		},
		COMMUNICATIONS: {
			path: 'communications',
			HOME: { path: '', url: () => '/admin/communications' },
			/**
			 * The old single-page builder. Now only a redirect — `?event=<EmailType>` goes to that email's
			 * page, without it to the list — kept because the URL is in bookmarks and shared links. Link to
			 * `EMAIL_TEMPLATES` instead.
			 */
			EMAIL_BUILDER: {
				path: 'email-builder',
			},
			/**
			 * One row per email, and a page per email keyed by its `EmailType` name — the same value an
			 * SMS template stores as its `key`, which is what makes the two screens linkable.
			 */
			EMAIL_TEMPLATES: {
				path: 'email-templates',
				LIST: { path: '', url: () => '/admin/communications/email-templates' },
				EDIT: {
					path: ':emailType/edit',
					url: (emailType: string) =>
						`/admin/communications/email-templates/${encodeURIComponent(emailType)}/edit`,
				},
				VIEW: {
					path: ':emailType',
					url: (emailType: string) =>
						`/admin/communications/email-templates/${encodeURIComponent(emailType)}`,
				},
			},
			SYSTEM_EMAILS: {
				path: 'system-email-notifications',
				url: () => '/admin/communications/system-email-notifications',
			},
			SETTINGS: { path: 'settings', url: () => '/admin/communications/settings' },
		},
		MESSAGE_TEMPLATES: {
			path: 'message-templates',
			LIST: { path: '', url: () => '/admin/message-templates' },
			CREATE: { path: 'create', url: () => '/admin/message-templates/create' },
			EDIT: { path: ':id/edit', url: (id: string) => `/admin/message-templates/${id}/edit` },
			VIEW: { path: ':id', url: (id: string) => `/admin/message-templates/${id}` },
		},
		SMS_TEMPLATES: {
			path: 'sms-templates',
			LIST: { path: '', url: () => '/admin/sms-templates' },
			// No CREATE. There is one template per communication event and the rows are seeded, so
			// there is nothing a "new SMS template" could mean — see SmsTemplateConstants on the server.
			EDIT: { path: ':id/edit', url: (id: string) => `/admin/sms-templates/${id}/edit` },
			VIEW: { path: ':id', url: (id: string) => `/admin/sms-templates/${id}` },
		},
		CANCELLATION_REASONS: {
			path: 'cancellation-reasons',
			LIST: { path: '', url: () => '/admin/cancellation-reasons' },
			CREATE: { path: 'create', url: () => '/admin/cancellation-reasons/create' },
			EDIT: { path: ':id/edit', url: (id: string) => `/admin/cancellation-reasons/${id}/edit` },
			VIEW: { path: ':id', url: (id: string) => `/admin/cancellation-reasons/${id}` },
		},
		PERMISSIONS: {
			path: 'permissions',
			url: () => '/admin/permissions',
		},
		CONFIG_THEME: {
			path: 'config-theme',
			url: () => '/admin/config-theme',
		},
		FEE_OPTIONS: {
			path: 'fee-options',
			LIST: { path: '', url: () => '/admin/fee-options' },
			CREATE: { path: 'create', url: () => '/admin/fee-options/create' },
			EDIT: { path: ':id/edit', url: (id: string) => `/admin/fee-options/${id}/edit` },
			VIEW: { path: ':id', url: (id: string) => `/admin/fee-options/${id}` },
		},
		DYNAMIC_PRICING: {
			path: 'dynamic-pricing',
			LIST: { path: '', url: () => '/admin/dynamic-pricing' },
			CREATE: { path: 'create', url: () => '/admin/dynamic-pricing/create' },
			EDIT: { path: ':id/edit', url: (id: string) => `/admin/dynamic-pricing/${id}/edit` },
			VIEW: { path: ':id', url: (id: string) => `/admin/dynamic-pricing/${id}` },
		},
		DYNAMIC_BOOKINGS: {
			path: 'dynamic-bookings',
			FIELDS: {
				LIST: { path: 'fields', url: () => '/admin/dynamic-bookings/fields' },
				CREATE: { path: 'create', url: () => '/admin/dynamic-bookings/fields/create' },
				EDIT: { path: ':id/edit', url: (id: string) => `/admin/dynamic-bookings/fields/${id}/edit` },
				VIEW: { path: ':id', url: (id: string) => `/admin/dynamic-bookings/fields/${id}` },
			},
			SECTIONS: {
				LIST: { path: 'sections', url: () => '/admin/dynamic-bookings/sections' },
				CREATE: { path: 'create', url: () => '/admin/dynamic-bookings/sections/create' },
				EDIT: { path: ':id/edit', url: (id: string) => `/admin/dynamic-bookings/sections/${id}/edit` },
				VIEW: { path: ':id', url: (id: string) => `/admin/dynamic-bookings/sections/${id}` },
			},
		},
		REPORTING: 'reporting',
		OPERATIONS_DASHBOARD_PAGE: 'reporting/operations-dashboard',
		UTILISATION_REPORT: 'reporting/utilisation',
		SCHEDULED_REPORTS: {
			path: 'scheduled-reports',
			LIST: { path: '', url: () => '/admin/scheduled-reports' },
			CREATE: { path: 'create', url: () => '/admin/scheduled-reports/create' },
			EDIT: { path: ':id/edit', url: (id: string) => `/admin/scheduled-reports/${id}/edit` },
		},
		BOOKING_TRANSFERS: 'booking-transfers',
		ANYTIME_TICKET_TRANSFERS: 'anytime-ticket-transfers',
		DEV: {
			path: 'dev',
			SETUP: { path: 'dev/setup', url: () => '/admin/dev/setup' },
		},
	},
} as const;

/**
 * Whitelabel transalation IDS
 */
export const WLIDS = {
	actions: {
		back: {
			id: 'actions.back',
			defaultMessage: 'Back',
		},
		continue: {
			id: 'actions.continue',
			defaultMessage: 'Continue',
		},
		continueAsGuest: {
			id: 'actions.continueAsGuest',
			defaultMessage: 'Continue as guest',
		},
		createAccount: {
			id: 'actions.createAccount',
			defaultMessage: 'Create account',
		},
		goHome: {
			id: 'actions.goHome',
			defaultMessage: 'Go home',
		},
		submit: {
			id: 'actions.submit',
			defaultMessage: 'Submit',
		},
	},
	auth: {
		accountLocked: {
			id: 'auth.accountLocked',
			defaultMessage: 'Account is locked',
		},
		checkYourInbox: {
			id: 'auth.checkYourInbox',
			defaultMessage: 'Check your inbox',
		},
		checkYourInboxDescription: {
			id: 'auth.checkYourInboxDescription',
			defaultMessage:
				"We've sent an email to your inbox to verify your account. Once verified you can pick up where you left off.",
		},
		voucherRegistrationDescription: {
			id: 'auth.voucherRegistrationDescription',
			defaultMessage:
				"We've sent a verification email to your inbox. Once verified, we'll bring you right back to complete your voucher purchase.",
		},
		confirmAccount: {
			id: 'auth.confirmAccount',
			defaultMessage: 'Confirm account',
		},
		couldNotSendRequest: {
			id: 'auth.couldNotSendRequest',
			defaultMessage: 'Could not send request',
		},
		endSession: {
			id: 'auth.endSession',
			defaultMessage: 'End session',
		},
		forgotPassword: {
			id: 'auth.forgotPassword',
			defaultMessage: 'Forgot password?',
		},
		login: {
			id: 'auth.login',
			defaultMessage: 'Login',
		},
		loginOrSignUp: {
			id: 'auth.loginOrSignUp',
			defaultMessage: 'Login or Sign up',
		},
		logout: {
			id: 'auth.logout',
			defaultMessage: 'Logout',
		},
		emailCodeSent: {
			id: 'auth.emailCodeSent',
			defaultMessage: "We've emailed a 6-digit code to {email}. Enter it below to continue.",
		},
		emailCodeWait: {
			id: 'auth.emailCodeWait',
			defaultMessage:
				'A code was sent moments ago. You can request a new one in {seconds, plural, one {# second} other {# seconds}}.',
		},
		lockedTryAgainIn: {
			id: 'auth.lockedTryAgainIn',
			defaultMessage:
				'You have exceeded the maximum number of attempts. Please try again in {minutes, plural, one {# minute} other {# minutes}} or contact staff for assistance.',
		},
		signInLockedOut: {
			id: 'auth.signInLockedOut',
			defaultMessage:
				'Too many failed sign-in attempts. Please try again in {minutes, plural, one {# minute} other {# minutes}}, or use Forgot password to reset it now.',
		},
		accountDeactivated: {
			id: 'auth.accountDeactivated',
			defaultMessage: 'This account has been disabled. Please contact staff for assistance.',
		},
		emailCodeResent: {
			id: 'auth.emailCodeResent',
			defaultMessage: 'A new code has been sent. It can take a minute to arrive.',
		},
		resendEmailCode: {
			id: 'auth.resendEmailCode',
			defaultMessage: 'Send a new code',
		},
		invalidCodeAttempts: {
			id: 'auth.invalidCodeAttempts',
			defaultMessage: 'Invalid code. You have {attempts} attempts remaining.',
		},
		passwordAfterReset: {
			id: 'auth.passwordAfterReset',
			defaultMessage:
				"Email sent! Check your inbox. Your link to re-enter paradise is on its way. If you don't see it, check your spam folder.",
		},
		passwordReset: {
			id: 'auth.passwordReset',
			defaultMessage:
				"It happens! We'll send a link to the email below to reset your password and you can be on your way to paradise again.",
		},
		registerNewUser: {
			id: 'auth.registerNewUser',
			defaultMessage: 'Register new user',
		},
		sendResetEmail: {
			id: 'auth.sendResetEmail',
			defaultMessage: 'Send reset email',
		},
		setupTwoFactorAuth: {
			id: 'auth.setupTwoFactorAuth',
			defaultMessage: 'Setup two factor authentication',
		},
		skipTwoFactor: {
			id: 'auth.skipTwoFactor',
			defaultMessage: 'Skip this step for 14 days',
		},
		stayLoggedIn: {
			id: 'auth.stayLoggedIn',
			defaultMessage: 'Stay logged in',
		},
		twoFactorEnterCode: {
			id: 'auth.twoFactorEnterCode',
			defaultMessage: 'Please enter the code from your authenticator app to complete the login process.',
		},
		twoFactorLocked: {
			id: 'auth.twoFactorLocked',
			defaultMessage:
				'You have exceeded the maximum number of attempts. Please try again in 15 minutes or contact staff for assistance.',
		},
		twoFactorScanQrCode: {
			id: 'auth.twoFactorScanQrCode',
			defaultMessage: 'Scan the QR code or enter the following key into your two factor authenticator app e.g. ',
		},
		verifyYourIdentity: {
			id: 'auth.verifyYourIdentity',
			defaultMessage: 'Verify your identity',
		},
		welcomeBack: {
			id: 'auth.welcomeBack',
			defaultMessage: 'Welcome back',
		},
	},
	form: {
		email: {
			id: 'form.email',
			defaultMessage: 'Email',
		},
		emailPlaceholder: {
			id: 'form.emailPlaceholder',
			defaultMessage: 'Enter email',
		},
		companyName: {
			id: 'form.companyName',
			defaultMessage: 'Company name',
		},
		companyNamePlaceholder: {
			id: 'form.companyNamePlaceholder',
			defaultMessage: 'Enter company name',
		},
		registerAsCompany: {
			id: 'form.registerAsCompany',
			defaultMessage: 'Register as a company',
		},
		contactFirstName: {
			id: 'form.contactFirstName',
			defaultMessage: 'Contact first name',
		},
		contactFirstNamePlaceholder: {
			id: 'form.contactFirstNamePlaceholder',
			defaultMessage: 'Enter contact first name',
		},
		contactLastName: {
			id: 'form.contactLastName',
			defaultMessage: 'Contact last name',
		},
		contactLastNamePlaceholder: {
			id: 'form.contactLastNamePlaceholder',
			defaultMessage: 'Enter contact last name',
		},
		firstName: {
			id: 'form.firstName',
			defaultMessage: 'First name',
		},
		firstNamePlaceholder: {
			id: 'form.firstNamePlaceholder',
			defaultMessage: 'Enter first name',
		},
		lastName: {
			id: 'form.lastName',
			defaultMessage: 'Last name',
		},
		lastNamePlaceholder: {
			id: 'form.lastNamePlaceholder',
			defaultMessage: 'Enter last name',
		},
		mobileNumber: {
			id: 'form.mobileNumber',
			defaultMessage: 'Mobile number',
		},
		mobileNumberPlaceholder: {
			id: 'form.mobileNumberPlaceholder',
			defaultMessage: 'Enter mobile number',
		},
		password: {
			id: 'form.password',
			defaultMessage: 'Password',
		},
		postcode: {
			id: 'form.postcode',
			defaultMessage: 'Postcode',
		},
		postcodePlaceholder: {
			id: 'form.postcodePlaceholder',
			defaultMessage: 'Enter postcode',
		},
	},
	guest: {
		details: {
			id: 'guest.details',
			defaultMessage: 'Guest details',
		},
		createAccountHeader: {
			id: 'guest.createAccountHeader',
			defaultMessage: 'Need to change your trip?',
		},
		createAccountBody: {
			id: 'guest.createAccountBody',
			defaultMessage:
				'Create a free account to change dates, add passengers, or update your booking details anytime — no need to call us!',
		},
		guest: {
			id: 'guest.guest',
			defaultMessage: 'Guest',
		},
	},
	validation: {
		emailAlreadyExists: {
			id: 'validation.emailAlreadyExists',
			defaultMessage: 'Account already exists. Please login.',
		},
		emailAlreadyExistsFromStaff: {
			id: 'validation.emailAlreadyExistsFromStaff',
			defaultMessage: 'Account already exists. Please select customer.',
		},
		emailRequired: {
			id: 'validation.emailRequired',
			defaultMessage: 'Please provide your email.',
		},
		nameInvalid: {
			id: 'validation.nameInvalid',
			defaultMessage: "No spaces. A-Z and '-' only.",
		},
		passwordRequired: {
			id: 'validation.passwordRequired',
			defaultMessage: 'Please provide your password.',
		},
		passwordTooShort: {
			id: 'validation.passwordTooShort',
			defaultMessage: 'Password is too short. Minimum {length} characters.',
		},
		passwordRequiresNonAlphanumeric: {
			id: 'validation.passwordRequiresNonAlphanumeric',
			defaultMessage: 'Include a special character.',
		},
		passwordRequiresDigit: {
			id: 'validation.passwordRequiresDigit',
			defaultMessage: 'Include at least one digit.',
		},
		passwordRequiresLower: {
			id: 'validation.passwordRequiresLower',
			defaultMessage: 'Include a lowercase letter.',
		},
		passwordRequiresUpper: {
			id: 'validation.passwordRequiresUpper',
			defaultMessage: 'Include an uppercase letter.',
		},
		passwordRequiresUniqueChars: {
			id: 'validation.passwordRequiresUniqueChars',
			defaultMessage: 'Use more unique characters ({count}).',
		},
		phoneAlreadyExists: {
			id: 'validation.phoneAlreadyExists',
			defaultMessage: 'Mobile already in use.',
		},
		required: {
			id: 'validation.required',
			defaultMessage: 'Required',
		},
	},
	addOns: {
		title: 'booking-details__add-ons-section__label',
	},
	resendBookingConfirmation: {
		title: 'resend-confirmation-email__title-v2',
		action: 'resend-confirmation-email__action',
		initiator: 'resend-confirmation-email__initiator',
	},
	customerTab: {
		userAdditionalInformation: 'customer-tab__user-additional-information__label-default',
	},
	overbooking: {
		genericNestedVehicle: 'reservation__overbooking-modal__generic-nested-vehicle-message',
		vehicle: 'reservation__overbooking-modal__vehicle-message',
		trailer: 'reservation__overbooking-modal__trailer-message',
		weight: 'reservation__overbooking-modal__weight-message',
		passenger: 'reservation__overbooking-modal__passenger-message',
		addOn: 'reservation__overbooking-modal__add-on-message',
		addOnTitle: 'reservation__overbooking-modal__add-on-title',
	},
	passengers: {
		firstNameLabel: {
			key: 'passenger-tab__first-name__label',
			default: 'First name',
		},
		lastNameLabel: {
			key: 'passenger-tab__last-name__label',
			default: 'Last name',
		},
		firstNamePlaceholder: {
			key: 'passenger-tab__first-name__placeholder',
			default: 'Enter your first name',
		},
		lastNamePlaceholder: {
			key: 'passenger-tab__last-name__placeholder',
			default: 'Enter your last name',
		},
	},
	reports: {
		viaEmailNotification: 'report-sent-via-email',
	},
	reservations: {
		customerTitle: 'reservation__overbooking-modal__title-for-customer',
		noInitialCapacityTitle: 'reservation__overbooking-modal__no-initial-capacity-title',
		selectNewTicket: 'reservation__overbooking-modal__select-new-ticket-text',
		back: 'reservation__overbooking-modal__back-text',
	},
	schedule: {
		book: 'ferry-schedule__trip-cards__book-now-button__label',
		view: 'ferry-schedule__trip-cards__view-button__label',
		private: 'ferry-schedule__trip-cards__private-text__label',
		finalised: 'ferry-schedule__trip-cards__finalise-text__label',
		goCheckIn: 'ferry-schedule__trip-cards__check-in-button__label',
	},
	standby: {
		callToAction: 'standby__call-to-action',
		preventNonAuthoriseCustomerMessage: 'standby__prevent-non-authorise-customer-message',
		modalTitle: 'standby__modal_join_list_title',
		listIsClosed: 'standby__list_is_closed',
		listIsFull: 'standby__list_is_full',
		addedToast: 'standby__added_toast',
		addFailedToast: 'standby__add_failed_toast',
		alreadyOnThisTripCount: 'standby__already_on_this_trip_count',
		modalMessage: 'standby__modal_join_list_message',
	},
	vehicle: {
		label: {
			key: 'vehicle__name__label',
			default: 'Vehicle',
		},
	},
	waitlist: {
		callToAction: 'add-to-waitlist__action-name',
	},
	width: {
		checkboxLabel: 'vehicle-tab__width-checkbox__label',
		dropdownLabel: 'vehicle-tab__width-dropdown__label',
		dropdownPlaceholder: 'vehicle-tab__width-dropdown__placeholder',
	},
} as const;

export const ERROR_CODES = {
	PHONE_ALREADY_EXISTS: 'PHONE_ALREADY_EXISTS',
	EMAIL_ALREADY_EXISTS: 'EMAIL_ALREADY_EXISTS',
	// A returning guest has to enter a code emailed to them (sent with 202, not an error).
	EMAIL_CODE_REQUIRED: 'EMAIL_CODE_REQUIRED',
	EMAIL_CODE_INVALID: 'EMAIL_CODE_INVALID',
	EMAIL_CODE_LOCKED: 'EMAIL_CODE_LOCKED',
	PASSWORD_TOO_SHORT: 'PASSWORD_TOO_SHORT',
	PASSWORD_REQUIRES_NON_ALPHANUMERIC: 'PASSWORD_REQUIRES_NON_ALPHANUMERIC',
	PASSWORD_REQUIRES_DIGIT: 'PASSWORD_REQUIRES_DIGIT',
	PASSWORD_REQUIRES_LOWER: 'PASSWORD_REQUIRES_LOWER',
	PASSWORD_REQUIRES_UPPER: 'PASSWORD_REQUIRES_UPPER',
	PASSWORD_REQUIRES_UNIQUE_CHARS: 'PASSWORD_REQUIRES_UNIQUE_CHARS',
	DEFAULT_PRICING_CUSTOMER_TYPE_TAKEN: 'DEFAULT_PRICING_CUSTOMER_TYPE_TAKEN',
} as const;

// Back-office CRUD for admin-managed resources, served by the bounded-context controllers under
// /api/admin. Kept separate from the *_ENTITY_URL / *_API_URL constants above because those are
// still the base for purpose-built sub-routes the public site calls (get-all-locations,
// fetch-all-routes, get-all-languages, get-all-passenger-types, ...), which are unaffected by the
// admin migration.
export const ADDITIONAL_BOOKING_OPTION_ADMIN_URL = `${SERVER_URL}/api/admin/booking-config/add-on-options`;
export const ADDITIONAL_BOOKING_SECTION_ADMIN_URL = `${SERVER_URL}/api/admin/booking-config/add-on-sections`;
export const PERMISSION_ADMIN_URL = `${SERVER_URL}/api/admin/permissions`;
export const BACKGROUND_JOB_CONFIG_ADMIN_URL = `${SERVER_URL}/api/admin/system/background-job-configs`;
export const BANNER_ADMIN_URL = `${SERVER_URL}/api/admin/site-config/banners`;
export const BOOKING_CUTOFF_ADMIN_URL = `${SERVER_URL}/api/admin/booking-config/booking-cutoffs`;
export const CUTOFF_EXPLAIN_ADMIN_URL = `${SERVER_URL}/api/admin/booking-config/booking-cutoffs/explain`;
export const CAPACITY_RESTRICTION_ADMIN_URL = `${SERVER_URL}/api/admin/vehicles/capacity-restrictions`;
export const CAPACITY_TYPE_ADMIN_URL = `${SERVER_URL}/api/admin/vehicles/capacity-types`;
export const CARGO_CHARACTERISTIC_ADMIN_URL = `${SERVER_URL}/api/admin/vehicles/cargo-characteristics`;
export const CARGO_TYPE_ADMIN_URL = `${SERVER_URL}/api/admin/vehicles/cargo-types`;
export const CHECK_IN_STATUS_ADMIN_URL = `${SERVER_URL}/api/admin/booking-config/check-in-statuses`;
export const CONFIG_GENERAL_ADMIN_URL = `${SERVER_URL}/api/admin/site-config/general`;
export const CONFIG_THEME_ADMIN_URL = `${SERVER_URL}/api/admin/site-config/theme`;
export const ENTITLEMENT_PRODUCT_ADMIN_URL = `${SERVER_URL}/api/admin/system/products`;
export const POS_PRODUCT_ADMIN_URL = `${SERVER_URL}/api/admin/system/pos-products`;
export const DEFAULT_PRICING_ADMIN_URL = `${SERVER_URL}/api/admin/pricing/default-pricing`;
export const DYNAMIC_BOOKING_FIELD_ADMIN_URL = `${SERVER_URL}/api/admin/booking-config/dynamic-fields`;
export const DYNAMIC_BOOKING_SECTION_ADMIN_URL = `${SERVER_URL}/api/admin/booking-config/dynamic-sections`;
export const DYNAMIC_PRICING_ADMIN_URL = `${SERVER_URL}/api/admin/pricing/dynamic-prices`;
export const EVENT_LABEL_ADMIN_URL = `${SERVER_URL}/api/admin/site-config/event-labels`;
export const CANCELLATION_REASON_ADMIN_URL = `${SERVER_URL}/api/admin/booking-config/cancellation-reasons`;
// The picker feed used by the cancellation wizard: already filtered for the caller's role and the
// booking being cancelled, unlike the admin URL above which lists every row.
export const CANCELLATION_REASON_API_URL = `${SERVER_URL}/api/cancellation-reasons`;
export const FEE_OPTION_ADMIN_URL = `${SERVER_URL}/api/admin/pricing/fee-options`;
export const FERRY_ADMIN_URL = `${SERVER_URL}/api/admin/transportation/ferries`;
export const CAPACITY_PROFILE_ADMIN_URL = `${SERVER_URL}/api/admin/transportation/capacity-profiles`;
/** A deck's own resources — its plan image. The decks themselves hang off a ferry. */
export const DECK_ADMIN_URL = `${SERVER_URL}/api/admin/transportation/decks`;
export const FREIGHT_CATEGORY_ADMIN_URL = `${SERVER_URL}/api/admin/freight/categories`;
export const FREIGHT_PRICE_RANGE_ADMIN_URL = `${SERVER_URL}/api/admin/freight/price-ranges`;
export const FREIGHT_TYPE_ADMIN_URL = `${SERVER_URL}/api/admin/freight/types`;
export const LANGUAGE_ADMIN_URL = `${SERVER_URL}/api/admin/site-config/languages`;
export const LOCATION_ADMIN_URL = `${SERVER_URL}/api/admin/transportation/locations`;
export const MESSAGE_TEMPLATE_ADMIN_URL = `${SERVER_URL}/api/admin/communications/message-templates`;
export const SMS_TEMPLATE_ADMIN_URL = `${SERVER_URL}/api/admin/communications/sms-templates`;
export const COMMUNICATION_EVENTS_URL = `${SERVER_URL}/api/admin/communications/communication-events`;
// The signed-in customer's own preferences. Not under /api/admin — it is scoped to the caller,
// with no user id in the route, so there is nothing for a customer to point at someone else.
export const COMMUNICATION_PREFERENCES_URL = `${SERVER_URL}/api/communication-preferences`;
export const MEASUREMENT_ADMIN_URL = `${SERVER_URL}/api/admin/vehicles/measurements`;
export const PARKING_CAPACITY_RESTRICTION_ADMIN_URL = `${SERVER_URL}/api/admin/parking/capacity-restrictions`;
export const PARKING_LOCATION_ADMIN_URL = `${SERVER_URL}/api/admin/parking/locations`;
export const PARKING_PRICING_TIER_ADMIN_URL = `${SERVER_URL}/api/admin/parking/pricing-tiers`;
export const PARKING_VEHICLE_TYPE_ADMIN_URL = `${SERVER_URL}/api/admin/parking/vehicle-types`;
export const PASSENGER_TYPE_ADMIN_URL = `${SERVER_URL}/api/admin/booking-config/passenger-types`;
export const PASSENGER_CLASS_ADMIN_URL = `${SERVER_URL}/api/admin/booking-config/passenger-classes`;
export const ROUTE_ADMIN_URL = `${SERVER_URL}/api/admin/transportation/routes`;
export const STOP_ADMIN_URL = `${SERVER_URL}/api/admin/transportation/stops`;
export const TOW_ON_TYPE_ADMIN_URL = `${SERVER_URL}/api/admin/vehicles/tow-on-types`;
export const USER_DISPLAY_NAME_ADMIN_URL = `${SERVER_URL}/api/admin/site-config/user-display-names`;
export const WIDTH_ADMIN_URL = `${SERVER_URL}/api/admin/vehicles/widths`;
export const PROMOTION_ADMIN_URL = `${SERVER_URL}/api/admin/pricing/promotions`;
